import { cn } from "@/lib/utils";
import { FC, HTMLAttributes } from "react";

type PageHeaderProps = HTMLAttributes<HTMLDivElement> & {
  icon?: React.ReactNode;
  title: string;
  afterHeading?: React.ReactNode;
};

const PageHeader: FC<PageHeaderProps> = ({
  icon,
  title,
  afterHeading,
  className,
  ...props
}) => {
  return (
    <header
      className={cn("flex justify-center gap-4 border-b pb-4", className)}
      {...props}
    >
      {icon && (
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-[#1E1C40] text-white">
          {icon}
        </div>
      )}

      <div className="mt-0.5 grow">
        <h1 className="text-3xl font-semibold text-[#293038]">{title}</h1>
        {afterHeading}
      </div>

      <div className="shrink-0">{props.children}</div>
    </header>
  );
};

export default PageHeader;
